export const filterColors = [
    {
        hex: "#FFFFFF",
        name: "White",
    },
    {
        hex: "#0074d9",
        name: "Blue",
    },
    {
        hex: "#FFFF00",
        name: "Yellow",
    },
    {
        hex: "#36454f",
        name: "Black",
    },
    {
        hex: "#5eb160",
        name: "Green",
    },
    {
        hex: "#d34b56",
        name: "Red",
    },
    {
        hex: "#f1a9c4",
        name: "Pink",
    },
    {
        hex: "#3d9970",
        name: "Olive",
    },
];
